<template>
  <div class="workshopSetting">
    <div class="componentTop">
      <div class="componentText">作业设置</div>
    </div>
    <div>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="基本信息" key="1">
          <basciMessage ref="basciMessage"></basciMessage>
          <advancedSetup @basciMessageSubmit="basciMessageSubmit"></advancedSetup>
        </a-tab-pane>
        <!-- <a-tab-pane tab=高级设置 key="2" forceRender>
          
        </a-tab-pane> -->
      </a-tabs>
    </div>
  </div>
</template>

<script>
import basciMessage from './basciMessage';
import advancedSetup from './advancedSetup';
export default {
  components: {
    basciMessage,
    advancedSetup
  },
  methods:{
    basciMessageSubmit(){
      this.$refs.basciMessage.onSubmit();
    }
  }
};
</script>

<style lang="less">
.workshopSetting{
  text-align: start;
  .ant-tabs-nav-wrap{
    padding-left: 20px;
  }
  .componentTop{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 25px 40px;
  }
  .componentText{
    font-size: 30px;
    color: #333333;
  }
}
</style>